import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ResourcesIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.75 5.5C5.61193 5.5 5.5 5.61193 5.5 5.75V18.25C5.5 18.3881 5.61192 18.5 5.75 18.5H17.25C17.6642 18.5 18 18.8358 18 19.25C18 19.6642 17.6642 20 17.25 20H5.75C4.78352 20 4 19.2165 4 18.25V5.75C4 4.78349 4.78351 4 5.75 4H14.25C15.2165 4 16 4.78352 16 5.75V10C16 10.4142 15.6642 10.75 15.25 10.75C14.8358 10.75 14.5 10.4142 14.5 10V5.75C14.5 5.61192 14.3881 5.5 14.25 5.5H5.75Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5 9.75C14.5 9.33579 14.8358 9 15.25 9H17.5227C18.8909 9 20 10.1091 20 11.4773V17.25C20 18.7688 18.7688 20 17.25 20C15.7312 20 14.5 18.7688 14.5 17.25V9.75ZM16 10.5V17.25C16 17.9404 16.5596 18.5 17.25 18.5C17.9404 18.5 18.5 17.9404 18.5 17.25V11.4773C18.5 10.9375 18.0625 10.5 17.5227 10.5H16Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.75 8.5C8.61193 8.5 8.5 8.61193 8.5 8.75V10.25C8.5 10.3881 8.61192 10.5 8.75 10.5H11.25C11.3881 10.5 11.5 10.3881 11.5 10.25V8.75C11.5 8.61192 11.3881 8.5 11.25 8.5H8.75ZM7 8.75C7 7.78351 7.78351 7 8.75 7H11.25C12.2165 7 13 7.78352 13 8.75V10.25C13 11.2165 12.2165 12 11.25 12H8.75C7.78352 12 7 11.2165 7 10.25V8.75Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.25 13.75C7.25 13.3358 7.58579 13 8 13H12C12.4142 13 12.75 13.3358 12.75 13.75C12.75 14.1642 12.4142 14.5 12 14.5H8C7.58579 14.5 7.25 14.1642 7.25 13.75Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.25 16.25C7.25 15.8358 7.58579 15.5 8 15.5H12C12.4142 15.5 12.75 15.8358 12.75 16.25C12.75 16.6642 12.4142 17 12 17H8C7.58579 17 7.25 16.6642 7.25 16.25Z"
        fill="currentColor"
      />
    </svg>
  );
};
